<form [formGroup]="formGroup" class="bg-white">
  <div class="development-title !text-[#21252A] !pl-[36px] sticky top-0 !z-50">
    Pre-Qualification Questionnaire (PQQ)
    <span class="comapny-general-info"> References </span>
  </div>

  <div class="container !px-[36px]">
    <!-- Refrences  -->
    <div #container_wrapper id="container_wrapper" class="container_wrapper">
      <mat-panel-title
        class="custom-panel-title !text-[20px] !font-semibold !text-[#21252A]"
      >
        References
      </mat-panel-title>

      <div
        class="container-fluid flex justify-center h-auto p-[29px] !pl-0 !pt-0 !m-[3px] !mt-[5px] !mb-[0px] !pb-[0px]"
      >
        <div class="!p-[30px] !pl-0 !pb-0 !bg-[#ffffff] w-full !pt-[0px]">
          <h3
            class="!text-[16px] font-semibold !mb-[0px] !pt-2 !pb-[10px] !text-[#21252A]"
          >
            Provide two references from recent construction projects. Include
            the following details:
          </h3>
          <h3
            class="!text-[18px] font-semibold !mb-[0px] !pt-[22px] !pb-[22px] !text-[#21252A]"
          >
          Reference 1
          </h3>
          <div
            class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2  gap-4 container"
          >
            <div class="container p-5 !pl-0 !pt-0 !mb-[40px] !pb-0">
              <div class="rounded">
                <mat-form-field
                  class="lg:!w-[26vw] md:!w-full !h-[4vh] !mb-[0px]"
                  appearance="outline"
                >
                  <mat-label> Client Name </mat-label>
                  <input
                    matInput
                    formControlName="ref_1_client_name"
                    placeholder="Client Name"
                  />
                </mat-form-field>
              </div>
            </div>

            <div class="container p-5 !pl-0 !pt-0 !mb-[40px] !pb-0">
              <div class="rounded  !pb-0 !pt-0">
                <mat-form-field
                  class="lg:!w-[26vw] md:!w-full !h-[4vh] !mb-[0px]"
                  appearance="outline"
                >
                  <mat-label> Project Title </mat-label>
                  <input
                    matInput
                    formControlName="ref_1_project_title"
                    placeholder="Project Title"
                  />
                </mat-form-field>
              </div>
            </div>

            <div class="container p-5 !pl-0 !pt-0 !mb-[40px] !pb-0">
              <div class="rounded">
                <mat-form-field
                  class="lg:!w-[26vw] md:!w-full !h-[4vh] !mb-[0px]"
                  appearance="outline"
                >
                  <mat-label> Contact Person </mat-label>
                  <input
                    matInput
                    formControlName="ref_1_contact_person"
                    placeholder="Contact Person"
                  />
                </mat-form-field>
              </div>
            </div>

            <div class="container p-5 !pl-0 !pt-0 !mb-[40px] !pb-0">
              <div class="rounded  !pb-0 !pt-0">
                <mat-form-field
                  class="lg:!w-[26vw] md:!w-full !h-[4vh] !mb-[0px]"
                  appearance="outline"
                >
                  <mat-label> Email Address </mat-label>
                  <input
                    matInput
                    type="email"
                    formControlName="ref_1_email"
                    placeholder="Email Address"
                  />
                </mat-form-field>
              </div>
            </div>

            <div class="container p-5 !pl-0 !pt-0 !mb-[40px] !pb-0">
              <div class="rounded">
                <mat-form-field
                  class="lg:!w-[26vw] md:!w-full !h-[4vh] !mb-[0px]"
                  appearance="outline"
                >
                  <mat-label> Telephone Number </mat-label>
                  <input
                    matInput
                    formControlName="ref_1_phone"
                    placeholder="Telephone Number"
                    [maxlength]="maxLength?.MOBILE_PHONE"
                    (keypress)="allowOnlyNumbers($event)"
                  />
                </mat-form-field>
              </div>
              <mat-error
                class="!mt-[20px]"
                *ngIf="
                  formGroup.get('ref_1_phone').hasError('pattern') &&
                  formGroup.get('ref_1_phone').touched
                "
              >
                Invalid telephone number format
              </mat-error>
            </div>
          </div>

          <h3
            class="!text-[18px] font-semibold !text-[#21252A] !mb-[0px] !pt-[0px] !pb-[22px]"
          >
            Reference 2
          </h3>
          <div
            class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-4 container !mb-[0px]"
          >
            <div class="container p-5 !pl-0 !pt-0 !mb-[40px] !pb-0">
              <div class="rounded ">
                <mat-form-field
                  class="lg:!w-[26vw] md:!w-full !h-[4vh] !mb-[0px]"
                  appearance="outline"
                >
                  <mat-label> Client Name </mat-label>
                  <input
                    matInput
                    formControlName="ref_2_client_name"
                    placeholder="Client Name"
                  />
                </mat-form-field>
              </div>
            </div>

            <div class="container p-5 !pl-0 !pt-0 !mb-[40px] !pb-0">
              <div class="rounded  !pb-0 !pt-0">
                <mat-form-field
                  class="lg:!w-[26vw] md:!w-full !h-[4vh] !mb-[0px]"
                  appearance="outline"
                >
                  <mat-label> Project Title </mat-label>
                  <input
                    matInput
                    formControlName="ref_2_project_title"
                    placeholder="Project Title"
                  />
                </mat-form-field>
              </div>
            </div>

            <div class="container p-5 !pl-0 !pt-0 !mb-[40px] !pb-0">
              <div class="rounded ">
                <mat-form-field
                  class="lg:!w-[26vw] md:!w-full !h-[4vh] !mb-[0px]"
                  appearance="outline"
                >
                  <mat-label> Contact Person </mat-label>
                  <input
                    matInput
                    formControlName="ref_2_contact_person"
                    placeholder="Contact Person"
                  />
                </mat-form-field>
              </div>
            </div>

            <div class="container p-5 !pl-0 !pt-0 !mb-[40px] !pb-0">
              <div class="rounded !pb-0 !pt-0">
                <mat-form-field
                  class="lg:!w-[26vw] md:!w-full !h-[4vh] !mb-[0px]"
                  appearance="outline"
                >
                  <mat-label> Email Address </mat-label>
                  <input
                    matInput
                    type="email"
                    formControlName="ref_2_email"
                    placeholder="Email Address"
                  />
                </mat-form-field>
              </div>
            </div>

            <div class="container p-5 !pl-0 !pt-0 !mb-[20px] !pb-0">
              <div class="rounded">
                <mat-form-field
                  class="lg:!w-[26vw] md:!w-full !h-[4vh] !mb-[0px]"
                  appearance="outline"
                >
                  <mat-label> Telephone Number </mat-label>
                  <input
                    matInput
                    formControlName="ref_2_phone"
                    placeholder="Telephone Number"
                    [maxlength]="maxLength?.MOBILE_PHONE"
                    (keypress)="allowOnlyNumbers($event)"
                  />
                </mat-form-field>
              </div>
              <mat-error
                class="!mt-[20px]"
                *ngIf="
                  formGroup.get('ref_2_phone').hasError('pattern') &&
                  formGroup.get('ref_2_phone').touched
                "
              >
                Invalid telephone number format
              </mat-error>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>
